import BFLLazyLoad from "@repo/shared-ui/BFLLazyLoad";
import { FC } from "react";
import { ICompany } from "../News/components/CompanyTag";
import RenderOpenDematFloatBanner from "./OpenDematFloatBanner";
import OpenDematFloatBannerSkeleton from "./OpenDematFloatBannerSkeleton";

export interface HzBannerAction {
  openDematButtonText: string;
  resumeJourneyText?: string;
  showUnifiedCt?: boolean | string;
  low_brokerage_img?: string;
  showTradeNow?: boolean | string;
  tradenowText?: string;
  showBuySellButtons?: boolean | string;
  buyText?: string;
  sellText?: string;
  brokerageLabelText?: string;
  brokerageMainText?: string;
  floatingBannerMainText?: string;
  floatingBannerSubText?: string;
  showFloatingBannerOnDesktop?: boolean | string;
  showFloatingBannerOnMobile?: boolean | string;
  showFloatingBannerOnScroll?: boolean | string;
  headerName?: string;
  isPdp?: boolean;
  showCtaPadding?: boolean | string;
  modalTitle?: string;
  loadOnPageLoad?: boolean | string;
}

const DEFAULT_LOW_BROKERAGE_IMG =
  "https://cms-assets.bajajfinserv.in/is/image/bajajfinance/low_brokerage_img?scl=3";

interface OpenDematFlowBannerWrapperProps {
  compName: string;
  exchId: string;
  formattedSymbol: string;
  nseToken: number;
  bseToken: number;
  content?: HzBannerAction;
  companies?: ICompany[];
}

const OpenDematFlowBannerWrapper: FC<OpenDematFlowBannerWrapperProps> = ({
  compName,
  exchId,
  formattedSymbol,
  nseToken,
  bseToken,
  content,
  companies,
}) => {
  const {
    openDematButtonText = "OPEN DEMAT ACCOUNT",
    resumeJourneyText,
    showUnifiedCt,
    showTradeNow,
    tradenowText,
    showBuySellButtons,
    buyText,
    low_brokerage_img,
    sellText,
    brokerageLabelText,
    brokerageMainText,
    floatingBannerMainText,
    floatingBannerSubText,
    showFloatingBannerOnDesktop,
    showFloatingBannerOnMobile,
    showFloatingBannerOnScroll,
    headerName,
    isPdp,
    showCtaPadding,
    modalTitle,
    loadOnPageLoad,
  } = content || {};

  // Convert string booleans to actual booleans
  const convertToBoolean = (value: boolean | string | undefined): boolean | undefined => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value === "true";
    return undefined;
  };

  const shouldLoadOnPageLoad = convertToBoolean(loadOnPageLoad) ?? false;
  const shouldShowOnScroll = convertToBoolean(showFloatingBannerOnScroll) ?? false;

  const bannerProps = {
    openDematButtonText: openDematButtonText ?? "OPEN DEMAT ACCOUNT",
    resumeJourneyText,
    showUnifiedCt: convertToBoolean(showUnifiedCt) ?? true,
    bseToken,
    nseToken,
    formattedSymbol,
    exchId,
    compName,
    showTradeNow: convertToBoolean(showTradeNow),
    tradeNowText: tradenowText,
    showBuySellButtons: convertToBoolean(showBuySellButtons),
    buyText,
    low_brokerage_img: low_brokerage_img ?? DEFAULT_LOW_BROKERAGE_IMG,
    sellText,
    brokerageLabelText,
    brokerageMainText,
    floatingBannerMainText,
    floatingBannerSubText,
    showFloatingBannerOnDesktop: convertToBoolean(showFloatingBannerOnDesktop),
    showFloatingBannerOnMobile: convertToBoolean(showFloatingBannerOnMobile),
    showFloatingBannerOnScroll: convertToBoolean(showFloatingBannerOnScroll),
    headerName,
    companies,
    isPdp: convertToBoolean(isPdp),
    showCtaPadding: convertToBoolean(showCtaPadding),
    modalTitle,
    loadOnPageLoad: shouldLoadOnPageLoad,
  };

  if (shouldLoadOnPageLoad) {
    return <RenderOpenDematFloatBanner {...bannerProps} />;
  }

  if (shouldShowOnScroll) {
    return (
      <BFLLazyLoad triggerOnScroll={true}>
        <RenderOpenDematFloatBanner {...bannerProps} />
      </BFLLazyLoad>
    );
  }

  return (
    <BFLLazyLoad fallback={<OpenDematFloatBannerSkeleton />}>
      <RenderOpenDematFloatBanner {...bannerProps} />
    </BFLLazyLoad>
  );
};

export default OpenDematFlowBannerWrapper;